export default {
  WhtTypeCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
